import withTracker from '.././withTracker';
import SubscribePayment from "../../containers/subscriber/SubscribePayment";

const subscribePayment = {
  path: '/subscribers/subscribePayment',
  component: withTracker(SubscribePayment)
};

export default subscribePayment;
